module.exports = __webpack_public_path__ + "static/blmlogo-fea952b3e56477cf065d095eb090b640.png";